import React, { useLayoutEffect } from 'react';

import HeaderV3 from '../../../components/HeaderV3/headerV3.component';
import NewsInnerSection from '../../../components/NewsInnerSection/newsinnersection.component';
import OrbixContact from '../../../components/ContactSection/contact.component';
import FooterSection from '../../../components/FooterSection/footersection.component';



import { Fragment } from "react";


function NewsInner() {
  useLayoutEffect(() => {
    document.body.style.backgroundColor = '#131022';
    return () => { document.body.style.backgroundColor = ''; };
  }, []);
  return (
    <Fragment>
    {/* main */}
    <main className="page-wrapper dark-mode">
    {/* Header  */}
    <HeaderV3 />

    {/* Hero  */}
   

    {/* Partners Section  */}
    <NewsInnerSection/>

    {/* Contact -1 */}
    <OrbixContact/>

    <FooterSection />
    </main>

    </Fragment>
  )
}

export default NewsInner